import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosConfig from '../../../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, Box, Button, Divider, Grid, Typography } from '@material-ui/core';
import ClassworkModal from '../../Modals/ClassworkModal';

import { StateContext, DispatchContext } from '../../../../../context/Provider';

/* Contenxt */
// import StateContext from '../../../../../context/StateContext';
// import DispatchContext from '../../../../../context/DispatchContext';

// move this to ClassworkTopic component later
const useStyles = makeStyles((theme) => ({
    heading: {
        fontSize: '0.875rem',
        fontWeight: 500
        // fontSize: theme.typography.pxToRem(14),
        // fontWeight: theme.typography.fontWeightRegular,
        // color: ''
    },
}));

const ClassworkItem = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState, globalState, facultyState } = appState;
    const { globalDispatch } = appDispatch;

    const { expanded, handleChange, classworkID, title, description } = props;
    const classes = useStyles();

    const [classwork, setClasswork] = useState({});
    const [classworkModalOpen, setClassworkModalOpen] = useState(false);
    const handleClassworkModalOpen = () => {
        fetchClasswork(props.classworkID);
    }

    const handleClassworkModalClose = () => {
        setClassworkModalOpen(false);
    }

    async function fetchClasswork(classworkID) {
        try {
            const response = await axiosConfig.get(`/classworks/${classworkID}`);
            const { data } = response.data;

            setClasswork(data);

        } catch (e) {
            console.log(e);
        }

        setClassworkModalOpen(true);
    }

    async function removeClasswork(classworkID) {

        globalDispatch({type: 'setIsLoading', value: true});

        try {
            const response = await axiosConfig.post(`/classworks/${classworkID}`, {
                _method: "DELETE"
            });

            const { status_code, message } = response.data;

            if (status_code === 'ok') {
                console.log(message);
                props.fetchClassworks();
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {
        // console.log('ClassworkItem rendered');
    }, []);

    const FacultyActionBtn = () => (
        <AccordionActions style={{justifyContent: 'flex-start'}}>
            <Box pl={0.1} alignItems="flex-start">
                <Button
                    color="primary"
                    component={Link}
                    to={`/${props.classcode}/classworkSubmissions/${classworkID}`}
                >
                    View classwork
                </Button>
                <Button color="primary" onClick={handleClassworkModalOpen}>Edit</Button>
                <Button color="primary" onClick={() => {
                    if (window.confirm(`Are you sure you want to remove this item?`)) {
                        // handleClose();
                        removeClasswork(classworkID);
                    }
                }}>Delete</Button>
            </Box>
        </AccordionActions>
    );

    const StudentActionBtn = () => (
        <AccordionActions style={{justifyContent: 'flex-start'}}>
            <Box pl={0.1} alignItems="flex-start">
                <Button
                    color="primary"
                    component={Link}
                    to={`/${props.classcode}/classwork/${classworkID}`}
                >
                    View classwork
                </Button>
            </Box>
        </AccordionActions>
    );

    return (
        <>
            { classworkModalOpen ? (
                <ClassworkModal
                    open={classworkModalOpen}
                    handleClose={handleClassworkModalClose}
                    dialogTitle={`Edit Classwork`}
                    classcode={props.classcode}
                    classworkID={classworkID}
                    classwork={classwork}
                    // fetchTopics={fetchTopics}
                /> ) : null
            }

            <Accordion expanded={expanded === classworkID} onChange={handleChange(classworkID)}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${classworkID}-content`}
                    id={`${classworkID}-header`}
                >
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', fontStyle: props.isPublished ? 'normal' : 'italic', color: props.isPublished ? 'black' : '#6c757d'}}>
                        <Typography className={classes.heading}>
                            {title}

                            { authState.user.role_id !== 5 ? (
                                `${props.isGraded ? ' - Graded' : ''}`
                            ) : ''}
                        </Typography>
                        { !props.isPublished &&
                            <Typography className={classes.heading}>
                                Draft
                            </Typography>
                        }
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={9}>
                            <Typography>
                                {description}
                            </Typography>
                        </Grid>

                        { authState.user.role_id !== 5 && (
                            <Grid item xs={12} sm={3}>
                                <Box style={{display: 'inline-block', borderLeft: '1px solid #CECECE'}} px={2} my={1}>
                                    <Typography variant="h4">{props.turnedIn || 0}</Typography>
                                    <Typography variant="subtitle1" style={{fontSize: '12px'}}>Turned In</Typography>
                                </Box>

                                <Box style={{display: 'inline-block', borderLeft: '1px solid #CECECE'}} px={2} my={1}>
                                    <Typography variant="h4">{props.assigned || 0}</Typography>
                                    <Typography variant="subtitle1" style={{fontSize: '12px'}}>Assigned</Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </AccordionDetails>

                <Divider />

                {authState.user.role_id === 4 ? (<FacultyActionBtn />) : null }
                {authState.user.role_id === 5 ? (<StudentActionBtn />) : null }

            </Accordion>
        </>
    );
}

export default ClassworkItem;